import {Component, OnInit, ViewChild} from '@angular/core';
import {PublicReportsReportStore} from '../../shared/store/publicReports/public-reports-report.store';
import {Observable, combineLatest} from 'rxjs';
import {AdRPeriod, AdRReportType} from '../../shared/interfaces/ad-reports';
import {PublicReportData} from '../../shared/store/publicReports/public-reports';
import {selectInitIsLoaded, selectSite, selectSpace} from '../../shared/store/init/init.selectors';
import {Serializer} from '../../shared/interfaces/serializer';
import {Site} from '../../shared/interfaces/site';
import {Space} from '../../shared/interfaces/space';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState} from '../../shared/store/store';
import {reportOpenPeriodDialog} from '../../shared/store/report/report.actions';
import {DimensionComponentObject} from '../../shared/classes/dimension-component-object';
import {MetricComponentObject} from '../../shared/classes/metric-component-object';
import {Channel} from '../../shared/interfaces/channel';
import {DashboardReportComponent} from '../../reports/dashboard-report/dashboard-report/dashboard-report.component';

@Component({
  selector: 'app-public-reports-report',
  templateUrl: './public-reports-report.component.html',
  styleUrls: ['./public-reports-report.component.scss'],
  providers: [PublicReportsReportStore]
})
export class PublicReportsReportComponent implements OnInit {
  @ViewChild(DashboardReportComponent) public readonly dashboardReportComponent: DashboardReportComponent | undefined;

  public readonly publicReportData$: Observable<PublicReportData> = this._publicReportsReportStore.publicReportData$;
  public readonly reportType$: Observable<AdRReportType> = this._publicReportsReportStore.reportType$;
  public readonly createdBy$: Observable<string> = this._publicReportsReportStore.createdBy$;
  public readonly loading$: Observable<boolean> = this._publicReportsReportStore.loading$;
  public readonly drawerIsOpened$: Observable<boolean> = this._publicReportsReportStore.drawerIsOpened$;

  public readonly dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);
  public readonly space$: Observable<Serializer<Space>> = this._store.select(selectSpace);

  public readonly reportName$: Observable<string> = this._publicReportsReportStore.reportName$;
  public readonly reportPeriod$: Observable<AdRPeriod> = this._publicReportsReportStore.reportPeriod$;
  public readonly reportDimensions$: Observable<Array<DimensionComponentObject> | null> = this._publicReportsReportStore.reportDimensions$;
  public readonly reportMetrics$: Observable<Array<MetricComponentObject> | null> = this._publicReportsReportStore.reportMetrics$;
  public readonly reportConversionMetric$: Observable<MetricComponentObject | null | undefined> = this._publicReportsReportStore.reportConversionMetric$;
  public readonly reportChannel$: Observable<Serializer<Channel> | null | undefined> = this._publicReportsReportStore.reportChannel$;

  public readonly reportIsLoaded$: Observable<boolean> = this._publicReportsReportStore.loaded$;
  public readonly reportInformationIsLoaded$: Observable<boolean> = this._store.select(selectInitIsLoaded);
  public readonly reportSettingsIsLoaded$: Observable<boolean> = this._publicReportsReportStore.settingsLoaded$;

  public readonly datasetName$: Observable<string> = this.dataset$.pipe(
    map((dataset: Serializer<Site>) => dataset.attributes.name)
  );

  public readonly spaceName$: Observable<string> = this.space$.pipe(
    map((space: Serializer<Space>) => space.attributes.name)
  );

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _publicReportsReportStore: PublicReportsReportStore
  ) {}

  ngOnInit(): void {}

  public onOpenPeriodSetting(): void {
    this._publicReportsReportStore.onOpenPeriodSetting();
  }

  public onCloseDrawer(): void {
    this._publicReportsReportStore.closeDrawer();
  }

  public onDrawerOpenedChange(): void {
    if (this.dashboardReportComponent) {
      this.dashboardReportComponent.resize();
    }
  }

}
